export const TYPE_TEXT = 'text';
export const TYPE_TEXTAREA = 'textarea';
export const TYPE_CHECKBOX = 'checkbox';
export const TYPE_SELECT = 'select';
export const TYPE_SIGNATURE = 'signature';
export const TYPE_HTML = 'html';
export const TYPE_DATETIME = 'datetime';
export const TYPE_PIN = 'pin';
export const TYPE_PHOTO = 'photo';
export const TYPE_DRAWING = 'drawing';
export const TYPE_FILE_IMAGE = 'image';
export const TYPE_FILE_DOCUMENT = 'document';
export const TYPE_PAYMENT_METHOD = 'payment_method';
export const TYPE_TIPS = 'tips';
export const TYPE_CHARGE_AMOUNT = 'charge_amount';
export const REGEXP_EMAIL = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
export const REGEXP_URL = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

export default class Field {
    constructor(json) {
        json = json || {};
        this.id = json.id || '';
        this.field_id = json.field_id || '';
        this.version = json.version || '';
        this.value = json.value || null;
        this.group_id = json.group_id || '';
        this.is_visible = !!json.is_visible;
        this.title = json.title || '';
        this.consumer_label = json.consumer_label || '';
        this.description = json.description || '';
        this.text = json.text || {
            default: '',
            placeholder: '',
        };
        this.textarea = json.textarea || {
            default: '',
            placeholder: '',
        };
        this.type = json.type || '';
        this.datetime = json.datetime || '';
        this.options = json.options || [];
        this.html = json.html || {
            content: '',
        };
        this.is_optional = !!json.is_optional
        this.photo = json.photo || {
            is_stencil: false,
            stencil: '',
            stencil_url: '',
            multiple: false,
            show_consumer_gallery: false,
            gallery: [],
            type: TYPE_FILE_IMAGE
        };
        this.drawing = json.drawing || {
            id: '',
            stencil: {
                url: '',
                uuid: '',
                data: {
                    width: 0,
                    height: 0
                }
            },
            default_color: '#000000FF'
        };
        this.tips = json.tips || {
            id: '',
            title: '',
            description: '',
            label: '',
            show_fixed_presets: false,
            fixed_presets_config: [],
            show_percentage_presets: false,
            percentage_presets_config: []
        };
        this.payment_method = json.payment_method || {
            id: '',
        };
        this.charge_amount = json.charge_amount || {
            type: '',
            value: 0,
            notice: ''
        }
    }

    get isSubmitable() {
        return [
            TYPE_TEXT,
            TYPE_TEXTAREA,
            TYPE_CHECKBOX,
            TYPE_SELECT,
            TYPE_PHOTO,
            TYPE_DATETIME,
            TYPE_SIGNATURE,
            TYPE_DRAWING,
            TYPE_PAYMENT_METHOD,
            TYPE_TIPS,
            TYPE_CHARGE_AMOUNT
        ].includes(this.type);
    }
}